import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { Alert, AlertProps, styled } from '@mui/material';
import React from 'react';

const StyledAlert = styled(Alert)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.getContrastText(theme.palette.grey[100]),
  '& .MuiAlert-icon': {
    color: theme.palette.getContrastText(theme.palette.grey[100]),
  },
}));

export const MutedAlert = React.forwardRef<HTMLDivElement, AlertProps>(
  ({ icon = <RadioButtonUncheckedIcon />, ...props }, ref) => {
    return <StyledAlert ref={ref} icon={icon} {...props} />;
  },
);

MutedAlert.displayName = 'MutedAlert';
